'use strict'

import '../scss/main.scss';

window.$ = window.jQuery = require('jquery');

import 'bootstrap';

// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

if (document.querySelector('.main-slider-container')) {
  new Swiper('.main-slider-container', {
    // Optional parameters
    modules: [Autoplay, Pagination, Navigation],
    direction: 'horizontal',
    loop: true,
    speed: 400,
    slidesPerView: 1,
    spaceBetween: 80,
    // Responsive breakpoints
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
    },
   // If we need pagination
    pagination: {
      el: '.swiper-main-pagination',
      clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        },
    },
    navigation: {
      nextEl: '.swiper-main-button-next',
      prevEl: '.swiper-main-button-prev',
    },
  });
}

if (document.querySelector('.team-slider-container')) {
  new Swiper('.team-slider-container', {
    // Optional parameters
    modules: [Navigation],
    direction: 'horizontal',
    loop: false,
    speed: 400,
    slidesPerView: 3,
    spaceBetween: 24,
    breakpoints: {
      // when window width is >= 320px
      0: {
        slidesPerView: 1,
      },
      // when window width is >= 480px
      600: {
        slidesPerView: 2,
      },
      // when window width is >= 640px
      860: {
        slidesPerView: 3,
      }
    },
    navigation: {
      nextEl: '.swiper-button-team-next',
      prevEl: '.swiper-button-team-prev',
    },
  });
}

    
if (document.querySelector('.impact-slider-container') || document.querySelector('.tools-slider-container')) {
  
  'use strict';

  // breakpoint where swiper will be destroyed
  const breakpoint = window.matchMedia( '(min-width:768px)' );

  // keep track of swiper instances to destroy later
  let impactSwiper;
  let toolsSwiper;

  const breakpointChecker = function() {

    // if larger viewport and multi-row layout needed
    if ( breakpoint.matches === true ) {

      // clean up old instances and inline styles when available
    if ( impactSwiper !== undefined ) impactSwiper.destroy( true, true );
    if ( toolsSwiper !== undefined ) toolsSwiper.destroy( true, true );

    // or/and do nothing
    return;

      // else if a small viewport and single column layout needed
      } else if ( breakpoint.matches === false ) {

        // fire small viewport version of swiper
        return enableSwiper();

      }

  };

  const enableSwiper = function() {

    impactSwiper =  new Swiper('.impact-slider-container', {
      // Optional parameters
      modules: [Navigation, Autoplay],
      direction: 'horizontal',
      loop: false,
      speed: 400,
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-impact-next',
        prevEl: '.swiper-button-impact-prev',
      },
    });
  
    toolsSwiper =  new Swiper('.tools-slider-container', {
      // Optional parameters
      modules: [Navigation, Autoplay, Pagination],
      direction: 'horizontal',
      loop: false,
      speed: 400,
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: '.swiper-tools-pagination',
        clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          },
      },
      navigation: {
        nextEl: '.swiper-button-tools-next',
        prevEl: '.swiper-button-tools-prev',
      },
    });
  };

  // keep an eye on viewport size changes
  breakpoint.addListener(breakpointChecker);

  // kickstart
  breakpointChecker();
}




window.designamite = {

  init: function()
  {

    designamite.global.init()
    
    designamite.projectSearch.init()

  },

  global: require('./methods/global'),
  
  cookie: require('./methods/cookie-bar'),
  
  projectSearch: require('./methods/project-search'),

  setCookie: function(cname, cvalue, days) {
    var d = new Date();
    d.setTime(d.getTime() + (days*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  },

  getCookie: function(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
  },

  
  
    
  

}

designamite.init()